import { useCallback } from 'react';
import { FieldErrors, FieldName, FieldPathValue, FieldValues } from 'react-hook-form';

export const useValidationResolver = (validationSchema: any) => {
  return useCallback(
    async (data: any) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: any, currentError: any) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );
};

export const handleFieldErrors = (
  error: FieldErrors<FieldPathValue<FieldValues, FieldName<FieldValues>>>
) => {
  if (!error) return undefined;
  return [error.message];
};
